var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-mode"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"group"},[_c('LocalizedInput',{attrs:{"title":_vm.$t('name'),"translate":_vm.value.name}})],1)]),_c('div',{staticClass:"column"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }